module.exports = __webpack_public_path__ + "assets/img/2018_7.a4eeea91.png";